import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  useTheme,
  useMediaQuery,
  IconButton,
  Grid
} from '@material-ui/core';
import { SwiperSlide } from 'swiper/react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { useUpdatedNoticeStyles } from './styles';
import { STORAGE_ACTION_EVENT } from '@utils/storage';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { NavigateBefore } from '@material-ui/icons';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import assets from './assets';
import CustomizedSwiper from '@components/Customized/CustomizedSwiper';

const UpdatedNoticeDialog = () => {
  const classes = useUpdatedNoticeStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const notSeeingAgainDate = localStorage.getItem(
    STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_UPDATE
  );

  const notSeenForADayDate = localStorage.getItem(
    STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_UPDATE
  );

  const toDayDate = new Date();
  // 사파리 내장 Date parser호환을 위해 YYYY-MM-DD{T}HH:mm:ss 형식을 쓸 것.
  const endDate = new Date('2022-10-02T23:59:59');
  const isEnd = endDate.getTime() < toDayDate.getTime();
  const isNotSeeingAgain =
    notSeeingAgainDate && notSeeingAgainDate !== 'true'
      ? toDayDate.getTime() < new Date(notSeeingAgainDate).getTime()
        ? true
        : false
      : false;
  const isNotSeenForADay = notSeenForADayDate
    ? toDayDate.getTime() - new Date(notSeenForADayDate).getTime() <
      24 * 60 * 60 * 1000
      ? true
      : false
    : false;

  const [openState, setOpenState] = useState(() => {
    const isOpen = isNotSeeingAgain || isEnd || isNotSeenForADay ? false : true;
    return isOpen;
  });

  const [checkState, setCheckState] = useState(false);

  const updatedContents = [
    {
      title: `여러분의 소중한 리뷰를 남겨주세요`,
      subtitle: ` 이제 ‘발주서’를 작성하면 캐파 거래 리뷰를 작성할 수 있습니다.`,
      src: assets.Update.UPDATE_CAPA4
    },
    {
      title: `여러분의 소중한 리뷰를 남겨주세요`,
      subtitle: `거래 리뷰는 파트너 ‘회사소개서’에서 확인할 수 있습니다. 
거래할 업체 선정시 견적과 함께 리뷰를 참고해 주세요.`,
      src: assets.Update.UPDATE_CAPA5
    }
  ];

  const onCloseHandle = () => {
    localStorage.setItem(
      STORAGE_ACTION_EVENT.NOT_SEEN_FOR_A_DAY_UPDATE,
      new Date().toString()
    );
    setOpenState(false);
  };

  useEffect(() => {
    // 업데이트 팝업 다시 보지 않기를 선택한 경우, 해당 업데이트 팝업 표시 기간이 종료되면 해당 상태를 초기화함.
    if (isNotSeeingAgain && isEnd) {
      localStorage.removeItem(STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_UPDATE);
    }
    //eslint-disable-next-line
  }, []);

  if (!openState) return null;

  return (
    <Dialog
      open={openState}
      onClose={onCloseHandle}
      maxWidth="lg"
      fullWidth
      className={classes.wrapper}
    >
      {updatedContents.length > 1 && (
        <React.Fragment>
          <IconButton className={'navigateNext'}>
            <NavigateNextIcon />
          </IconButton>
          <IconButton className={'navigatePrev'}>
            <NavigateBefore />
          </IconButton>
        </React.Fragment>
      )}

      <DialogContent className={classes.content}>
        <CustomizedTypography
          className="title"
          variant={matches ? 'body2' : 'body1'}
          color="primary"
          fontWeight="700"
        >
          신규 업데이트
        </CustomizedTypography>

        {matches && updatedContents.length > 1 && (
          <Box className="swipe_button">
            <IconButton className={'mobileNavigatePrev'}>
              <ChevronLeft />
            </IconButton>
            <IconButton className={'mobileNavigateNext'}>
              <ChevronRight />
            </IconButton>
          </Box>
        )}
        <CustomizedSwiper
          className={classes.swipezone}
          slidesPerView={1}
          navigation={{
            nextEl: matches ? '.mobileNavigateNext' : '.navigateNext',
            prevEl: matches ? '.mobileNavigatePrev' : '.navigatePrev'
          }}
          pagination={{
            clickable: true,
            el: '.swiper-pagination',
            type: 'bullets'
          }}
          loop
        >
          {updatedContents.map(({ src, title, subtitle }, index) => (
            <SwiperSlide className={classes.slide} key={`update${index}`}>
              <Box className={classes.slideBox}>
                <CustomizedTypography
                  variant={matches ? 'h4' : 'h3'}
                  fontWeight="700"
                  gutterBottoms={12}
                >
                  {title}
                </CustomizedTypography>
                <CustomizedTypography
                  variant={matches ? 'subtitle2' : 'body2'}
                  color="textSecondary"
                  fontWeight="500"
                >
                  {subtitle}
                </CustomizedTypography>
                <Grid className="slideImg">
                  <img src={src} alt="slideImg" width="100%" />
                </Grid>
              </Box>
            </SwiperSlide>
          ))}
          {updatedContents.length > 1 && <div className="swiper-pagination" />}
        </CustomizedSwiper>

        <DialogActions className="content_buttons">
          <CustomizedButton fullWidth size="large" onClick={onCloseHandle}>
            닫기
          </CustomizedButton>
          <CustomizedButton
            variant="text"
            color="primary"
            onClick={() => {
              setCheckState(!checkState);
              setOpenState(false);
              localStorage.setItem(
                STORAGE_ACTION_EVENT.NOT_SEEING_AGAIN_UPDATE,
                endDate.toString()
              );
            }}
          >
            <CustomizedTypography variant={'body2'} color="primary">
              다시 보지 않기
            </CustomizedTypography>
          </CustomizedButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default UpdatedNoticeDialog;
